import { PlatformDraft } from '../types/api';
import { GENERATE_PLATFORMS } from '../constants/platforms';

/** Map integration API platform id to draft tab key. */
export const INTEGRATION_TO_DRAFT: Record<string, string> = {
  linkedin: 'linkedin',
  x: 'twitter',
  instagram: 'instagram',
};

export const DRAFT_TO_API_PLATFORM: Record<string, string> = {
  linkedin: 'linkedin',
  twitter: 'twitter',
  instagram: 'instagram',
};

export const PUBLISH_PLATFORMS = [...GENERATE_PLATFORMS];

/** Build custom_content payload for POST /social/post/multi. */
export function buildCustomContent(
  drafts: Record<string, PlatformDraft>,
  selectedDraftKeys: string[]
): Record<string, string> {
  const out: Record<string, string> = {};
  for (const draftKey of selectedDraftKeys) {
    const draft = drafts[draftKey];
    if (!draft?.content?.trim()) continue;
    const apiKey = DRAFT_TO_API_PLATFORM[draftKey] ?? draftKey;
    out[apiKey] = draft.content;
    if (draftKey === 'twitter') {
      out.x = draft.content;
    }
  }
  return out;
}

/** Platforms with draft content and within character limit. */
export function getPublishableDraftKeys(
  drafts: Record<string, PlatformDraft>
): string[] {
  return PUBLISH_PLATFORMS.filter((key) => {
    const draft = drafts[key];
    return Boolean(draft?.content?.trim() && draft.within_limit);
  });
}

/** Selected platforms that exceed character limits. */
export function getOverLimitSelections(
  drafts: Record<string, PlatformDraft>,
  selected: string[]
): string[] {
  return selected.filter((key) => {
    const draft = drafts[key];
    return draft && !draft.within_limit;
  });
}
